import React, { useState } from "react";
import { Modal, Header, Button, Form as FormUi, Table,List } from "semantic-ui-react";
import Axios from "axios";
import cogoToast from "cogo-toast";
import { importModalValidation,importModalText } from "../../utils/constants/commonComponents.constants";

const ImportModal = (props) => {
  const [file, setFile] = useState(0);
  const [isloading, setisloading] = useState(false);
  const [fileErrors, setFileErrors] = useState([]);
  const [fileErrorsflag, setfileErrorsFlag] = useState(false);
  const [showLogs, setShowLogs] = useState(false);
  const [statFailedCount, setStatFailedCount] = useState(0);
  const [statSuccessCount, setStatSuccessCount] = useState(0);
  const [importMsg, setimportMsg] = useState([])

  const handleFile = (e) => {
    let file = e.target.files[0];
    setFile(file);
  };
  const templateDownload = () => {
    if (props.titleBarTitle === 'Jobcard') {
      let fileName = 'ImportFuelJobcard';
      let url = `${process.env.REACT_APP_LCT_GATEWAY}/fleetService/storage/JobcardImport/${fileName}.xlsx`;
      window.open(url, '_blank');
    } else {
      let customerNo = Number(localStorage.getItem("customerNo"))
      let fileName = `${props.fileName}.xlsx`;
      var gett = localStorage.getItem("apiToken");
      let url=`${process.env.REACT_APP_BASE_URL}/masters/templateDownload/${customerNo}/${fileName}`;
      
      Axios.get(url,{
        headers: {
          "content-type": "multipart/form-data",
          Authorization: `${gett}`,
        },
        responseType:'blob'}).then((res)=>{
        var data = new Blob([res.data]);
        
          var blob = data;
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName;
          document.body.appendChild(link);
          link.click(); 
        
      })
    }
  };

  const logsDownload = () => {
    setfileErrorsFlag(true)
  };

  let handleUpload = (e) => {
    e.preventDefault();
    setisloading(true);
    if (file === "" || file === null || file === undefined) {
      setisloading(false);
    } else if (
      file.type !==
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ) {
      setisloading(false);
    } else {
      let fromData = new FormData();
      fromData.append("customerNumber", localStorage.getItem("customerNo"));
      fromData.append("userId", localStorage.getItem("userId"));
      fromData.append("customerNo", Number(localStorage.getItem("customerNo")));
      fromData.append("user_id", Number(localStorage.getItem("userId")));
      var gett = localStorage.getItem("isloggedIn");
      let url = ''
      if (props.titleBarTitle === 'Jobcard') {
        fromData.append("importedFile", file);
        url = `${process.env.REACT_APP_BASE_URL}/fleet/import/fuelJobcard`
      }
      else {
        gett = localStorage.getItem('apiToken')
        fromData.append("myfile", file);
        fromData.append("module","FL")
        url = `${process.env.REACT_APP_BASE_URL}/${props.importSubUrl}`;
      }

        Axios.post(url, fromData, {
        headers: {
          "content-type": "multipart/form-data",
          Authorization: `${gett}`,
        },
      })
        .then((response) => {
          if (props.titleBarTitle === 'Jobcard') {
          let responseFailure = response.data.failureSpecification;
          let failedCount = response.data.failedCount;
          let successCount = response.data.successCount;

          let logShare = [];

          setisloading(false)

          if (+failedCount > 0) {
            setShowLogs(true)
            setStatFailedCount(failedCount)
            setStatSuccessCount(successCount)
            cogoToast.warn(importModalValidation.ERROR_IMPORT, { hideAfter: '5' })
            for (const property in responseFailure) {
              let temp = {};
              temp.reason = `${responseFailure[property].reason}`
              temp.rowNumber = `${responseFailure[property].rowNumber}`
              logShare.push(temp)
            }
          } else {
            cogoToast.success(importModalValidation.SUCCESS_IMPORT, { hideAfter: '5' })
            window.location.reload();
          }

          setFileErrors(logShare)
        } else {
          if (response.data.resultSet.length > 0) {
            setimportMsg(response.data.resultSet)
          } else {
            window.location.reload();
          }
          cogoToast.success(importModalValidation.SUCCESS_IMPORT, { hideAfter: '5' })
        }
        })
        .catch((err) => {
          cogoToast.error(importModalValidation.FAILED_IMPORT, { hideAfter: '5' })
          setisloading(false);
        });
    }
  };

  return (
    <>

      <div>
        <Modal open={props.openBox} onClose={props.handleClose} size="small">
        {importMsg.length > 0 ?
            <>
              <div className="modal-header">
                <h4 className="modal-title">{importModalText.IMPORT} {props.ImportTitle} {importModalText.DETAIL}</h4>
                <button hidden={importMsg.length > 0 ? true : false} type="button" className="close" data-dismiss="modal">&times;</button>
              </div>
              <div style={{ height: '200px', overflowY: 'scroll' }}>
                {importMsg.map((o, i) => (
                  <>
                    <List className="p-2 pl-2 m-1 w3-border w3-border-blue">
                      <List.Item >
                        <List.Description> {`${importModalText.RECORDS} ${i + 1}:`}</List.Description>
                        <List.Header>{typeof o.message === 'object' ? o.message?.message : o.message}</List.Header>
                      </List.Item>
                    </List>
                  </>
                ))}
              </div>
              <center><button onClick={() => window.location.reload()} className="w3-button w3-small w3-blue w3-round w3-hover-blue p-outline-none m-2">OK</button></center>
            </>
            :
            fileErrorsflag == true ? (
              <>
                <Header>{importModalText.IMPORT_FILE_LOG}</Header>
                <Modal.Content scrolling>
                  <Modal.Description>
                    <p className="labelroboto">{importModalText.SUCCESS_UPLOAD} : {statSuccessCount}</p>
                    <p className="labelroboto">{importModalText.FAILED_UPLOAD} : {statFailedCount}</p>

                    <Table>
                      <Table.Header>
                        <Table.Row>
                          <Table.HeaderCell>
                            {importModalText.ROW_NUMBER}
                          </Table.HeaderCell>
                          <Table.HeaderCell>
                            {importModalText.ERROR}
                          </Table.HeaderCell>
                        </Table.Row>
                      </Table.Header>
                      <Table.Body>
                        {fileErrors.map((error, index) => (
                          <Table.Row>
                            <Table.Cell>
                              {error.rowNumber}
                            </Table.Cell>
                            <Table.Cell>
                              {error.reason}
                            </Table.Cell>
                          </Table.Row>
                        ))}
                      </Table.Body>
                    </Table>
                  </Modal.Description>
                </Modal.Content>
                <Modal.Actions>
                  <Button onClick={(e) => { e.stopPropagation(); setfileErrorsFlag(false); }} size="mini">
                    {importModalText.CANCEL}
                  </Button>
                </Modal.Actions>
              </>
            ) : (
              <>
                <Header>{importModalText.IMPORT_FILE}</Header>
                <Modal.Content>
                  <Modal.Description>
                    <FormUi.Group inline>
                      <FormUi.Field>
                        <label className="tiny ui form p-bold-600">
                          {importModalText.FORMAT_MESSAGE}
                        </label>
                      </FormUi.Field>
                    </FormUi.Group>
                    <FormUi.Group inline>
                      <FormUi.Field>
                        <label className="tiny ui form p-bold-300 w3-text-grey  pt-3">
                          {importModalText.UPLOAD_FILE} &nbsp;
                        </label>
                        <input
                          onChange={handleFile}
                          type="file"
                          className="w3-small"
                          id="validatedCustomFile"
                        />
                      </FormUi.Field>
                      <FormUi.Field>
                        <label className="tiny ui form pt-3">
                          <span className="p-bold-600 ">
                            {importModalText.DOWNLOAD_MESSAGE}{" "}
                            <span
                              className="w3-text-blue p-bold-300"
                              onClick={templateDownload}
                              style={{ cursor: "pointer" }}
                            >
                              {importModalText.HERE}
                            </span>
                          </span>
                        </label>
                      </FormUi.Field>
                      {showLogs &&
                        <FormUi.Field>
                          <label className="tiny ui form pt-3">
                            <span className="p-bold-600 ">
                              {importModalText.CHECK}{" "}
                              <span
                                className="w3-text-blue p-bold-300"
                                onClick={logsDownload}
                                style={{ cursor: "pointer" }}
                              >
                                {importModalText.LOGS}
                              </span>
                            </span>
                          </label>
                        </FormUi.Field>
                      }

                    </FormUi.Group>
                  </Modal.Description>
                </Modal.Content>
                <Modal.Actions>
                  {isloading ? <small>{importModalText.LOADING}</small> : ""}
                  <Button onClick={props.handleClose} size="mini">
                    {importModalText.CANCEL}
                  </Button>
                  <Button
                    onClick={handleUpload}
                    disabled={isloading ? true : false}
                    color="blue"
                    size="mini"
                  >
                    {importModalText.UPLOAD}
                  </Button>
                </Modal.Actions>

              </>
            )}
        </Modal>
      </div>

    </>
  );
};


export default ImportModal;
